/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { MENU_ITEM_NAMES } from 'constants/header'
import { Text } from 'hocs/localization'
import * as styles from './MobileMenu.scss'

const cx = classNames.bind(styles)

interface IItem {
  langPath: string,
  name: MENU_ITEM_NAMES,
}

interface IProps {
  items: IItem[],
  t: Text,
  isUserAuthorized: boolean,
  isVisible: boolean,
  onClickMenuItem: (event: React.SyntheticEvent, name: MENU_ITEM_NAMES) => void,
}

const MobileMenu: React.FC<IProps> = ({ items, t, isUserAuthorized, isVisible, onClickMenuItem }) => (
  <div className={cx(styles.mobileMenu, { visible: isVisible })}>
    <ul className={styles.list}>
      {items.map(({ name, langPath }, index) => {
        return (
          <li key={index} className={styles.item}>
            <a href='#' onClick={event => onClickMenuItem(event, name)}>
              {t(langPath)}
            </a>
          </li>
        )
      })}
      {!isUserAuthorized && [
        <li key={MENU_ITEM_NAMES.login} className={styles.item}>
          <a href='#' onClick={event => onClickMenuItem(event, MENU_ITEM_NAMES.login)}>
            {t('logIn')}
          </a>
        </li>,
        <li key={MENU_ITEM_NAMES.signUp} className={styles.item}>
          <a href='#' onClick={event => onClickMenuItem(event, MENU_ITEM_NAMES.signUp)}>
            {t('signUp')}
          </a>
        </li>,
      ]}
    </ul>
  </div>
)

export default MobileMenu
